import Header from "../../atoms/Header";
import DashboardTemplate from "../../templates/Dashboard";
import { NeedHelp } from "../../atoms/CustomIcons";
import { Tabs, TabsProps } from "antd";
import Materials from "./Components/Materials";
import { useEffect, useState } from "react";
import Equipment from "./Components/Equipment";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppSelector } from "../../config/hooks";

export default function Inventory() {
  const [tabValue, setTabValue] = useState("");
  const navigate = useNavigate();
  const url = useLocation();
  const type = url?.pathname.split("/")[2];
  const companyId = url?.pathname.split("/")[3];
  const materialListData = useAppSelector(
    (state) => state?.inventory?.materialListData
  );
  const equipmentDetailData = useAppSelector(
    (state) => state.inventory?.equipmentDetailData
  );

  const items: TabsProps["items"] = [
    {
      key: "materials",
      label: "Materials",
      children: <Materials setTabValue={setTabValue} />,
    },
    {
      key: "equipment",
      label: "Equipment",
      children: <Equipment setTabValue={setTabValue} />,
    },
  ];

  useEffect(() => {
    if (type) {
      setTabValue(type);
    } else {
      setTabValue("materials");
    }
  }, [type]);

  useEffect(() => {
    if (tabValue && companyId) {
      setTabValue(tabValue);
      navigate(`/inventory/${tabValue}/${companyId}`);
    }
  }, [tabValue, companyId, navigate]);

  console.log("url.pathname ", url.pathname);
  console.log("loader ", equipmentDetailData?.loader, materialListData?.loader);

  // const [loading, setLoading] = useState(false);
  // useEffect(() => {
  //   if (url.pathname.startsWith("/inventory/equipment")) {
  //     console.log(
  //       "Equipment Detail Data Loader: ",
  //       equipmentDetailData?.loader
  //     );
  //     setLoading(equipmentDetailData?.loader);
  //   } else if (url.pathname.startsWith("/inventory/materials")) {
  //     console.log("Material List Data Loader: ", materialListData?.loader);
  //     setLoading(materialListData?.loader);
  //   } else {
  //     setLoading(false);
  //   }
  // }, [url, equipmentDetailData?.loader, materialListData?.loader]);

  return (
    <div className="inventoryPage">
      <DashboardTemplate loading={false}>
        <Header
          title="Inventory"
          btnText1="Need help?"
          btnIcon1={<NeedHelp />}
        />
        <Tabs activeKey={tabValue} items={items} destroyInactiveTabPane />
      </DashboardTemplate>
    </div>
  );
}
